import createReducerMixin from "./createReducerMixin";
import Combiners from "abusesa-js/combiners";
import Charts from "../charts/index";
import Mappable from "lib/Mappable";
import pluralize from "pluralize";

const TOPFILTER_PROPS = ["topFilter", "topFn", "topCount", "topShowOthers"];

const getProps = (props) => {
    let opts = Charts[props.type || "BarChart"].options;
    let {data, title, stack = opts["stack"], topFilter, topFn, topCount = opts["topCount"], topShowOthers} = props;
    return {data, title, stack, topFilter, topFn, topCount, topShowOthers};
};

const defaultState = {data: undefined, title: undefined};

const topX = (state, _nextProps, _oldProps) => {
    let nextProps = getProps(_nextProps),
        oldProps = getProps(_oldProps);

    if (Object.keys(nextProps).every(key => nextProps[key] == oldProps[key])) {
        return state;
    }

    let {data, title, stack, topFilter, topFn, topCount, topShowOthers} = nextProps;

    if (!topFilter || data.length == 0 || data.keys("group").length == 0) {
        return defaultState;
    }

    let valKey = data.keys("y"),
        nameKey = data.keys("x"),
        gKey = data.keys("group"),
        getGroup = item => item[gKey];

    let avg = item => item["sum"] / item["# events"];
    let sum = item => item["sum"];

    let sortedGroups = data.combineWith({
        "group": new Combiners.Unique(gKey),
        "sum": new Combiners.Sum(valKey, {header: "sum"}),
        "count": new Combiners.Count(valKey, {header: "# events"})
    }).sort((a, b) => {
        let order = topFilter == "top" ? 1 : -1;
        let fn = topFn == "avg" ? avg : sum;
        return (fn(b) - fn(a)) * order;
    });

    let filteredGroups = sortedGroups.values("group").slice(0, topCount);

    let averages = data.combineWith({
        "x": nameKey != "" ? new Combiners.Unique(nameKey) : new Combiners.Dummy(),
        "sum": new Combiners.Sum(valKey, {header: "sum"}),
        "count": new Combiners.Count(valKey, {header: "# events"})
    }).map(item => ({
        [gKey]: " average",
        [valKey]: avg(item),
        [nameKey]: item[nameKey]
    }));

    let sums = data
        .filter(item => filteredGroups.indexOf(getGroup(item)) === -1)
        .collapse("group")
        .map(item => ({...item, [gKey]: " others"}));


    let others = stack ? sums : averages;

    data = data.filter(item => filteredGroups.indexOf(getGroup(item)) != -1);

    if (topShowOthers) {
        data.push(...others);
    }

    if (!title) {
        title = `${topFilter} ${topCount} ${pluralize.plural(""+gKey, topCount)}`;
        title += nameKey != "" ? ` over ${nameKey}` : "";
    }
    return {data, title};
};

export default function filterDataset(WrappedComponent) {
    return class TopFilter extends createReducerMixin(WrappedComponent, topX) {
        static displayName = 'TopFilter';

        render() {
            let state = new Mappable(this.state)
                .filter()
                .toObject();

            let {title, data} = {...this.props, ...state};

            let props = new Mappable(this.props)
                .filter((val, key) => !TOPFILTER_PROPS.includes(key))
                .toObject();

            return super.render({...props, data, title});
        }
    };
}



// WEBPACK FOOTER //
// ./src/kpi/common/TopFilter.js